import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { EstadoService } from './../../servicos/estado.service';
import { DaoService } from './../../servicos/dao.service';
import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(private dao: DaoService, public est: EstadoService, private router: Router, private conf: ConfirmationService) { }

  ngOnInit() {
    this.checarVersao();
  }



  cpf: any;
  nascimento: any;
  emManutencao: any = '';
  exibirProblemas: boolean = false;
  carregando: boolean = true;
  item: any = {
    nome: '',
    matricula: '',
    telefone: '',
    mensagem: ''
  };

  async checarVersao() {
    let res = await this.dao.submeter({}, 'versao', true);
    if (res.online == 'nao') {

      this.emManutencao = 'sim';
      return;
    }

    if (res.online == 'sim') {
      this.emManutencao = 'nao';
      this.carregando = false;
    }

    console.log(res, this.est.versao);
    if (res['texto'] !== this.est.versao) {
      console.log("atualizar");


      this.conf.confirm({
        message: "Sua versão está desatualizada (" + this.est.versao + "), clique em atualizar para obter a mais recente (" + res['texto'] + ").",
        header: "Versão desatualizada",
        acceptLabel: 'Atualizar',
        rejectLabel: 'Cancelar',
        accept: () => {
          window.location.reload();
        },
        reject: () => {
          window.location.replace("https://diviprev.mg.gov.br/?p=9633");
        }
      });
      // 
    }
  }


  async testeMensagem() {
    const resposta = await this.dao.submeter({ telefone: '37998552222', mensagem: 'Opa, teste de envio' }, 'notificar');
    console.log("Resposta ", resposta);
  }


  // ===== Teste de envio de WhatsApp (liberado apenas pelo segredo) =====
  // Segredo: clicar 10 vezes na palavra "Diviprev" e em seguida apertar a letra T.
  testeZapLiberado: boolean = false;
  cliquesSegredo: number = 0;
  private ultimoCliqueSegredo: number = 0;
  exibirTesteZap: boolean = false;
  enviandoTesteZap: boolean = false;
  testeZap: any = {
    telefone: '',
    mensagem: ''
  };
  retornoTesteZap: string = '';
  chamadaTesteZap: string = '';
  testeZapComErro: boolean = false;

  // Conta os cliques na palavra "Diviprev". Se o usuário parar por mais de 5
  // segundos entre um clique e outro, a contagem reinicia.
  contarCliqueSegredo() {
    const agora = Date.now();
    if (agora - this.ultimoCliqueSegredo > 5000) this.cliquesSegredo = 0;
    this.ultimoCliqueSegredo = agora;
    this.cliquesSegredo++;
  }

  // Segunda parte do segredo: com os 10 cliques feitos, a letra T libera o teste.
  @HostListener('document:keydown', ['$event'])
  teclaSegredo(event: any) {
    if (this.testeZapLiberado) return;
    if (this.cliquesSegredo < 10) return;

    const alvo = event && event.target ? (event.target.tagName || '') + '' : '';
    if (alvo.toLowerCase() == 'input' || alvo.toLowerCase() == 'textarea') return;

    if ((event.key + '').toLowerCase() != 't') return;

    this.testeZapLiberado = true;
    this.cliquesSegredo = 0;
    this.dao.toast('s', 'Teste de disparo de mensagem liberado.');
  }

  abrirTesteZap() {
    if (!this.testeZapLiberado) return;
    this.retornoTesteZap = '';
    this.chamadaTesteZap = '';
    this.testeZapComErro = false;
    this.exibirTesteZap = true;
  }

  fecharTesteZap() {
    this.exibirTesteZap = false;
  }

  // Monta o texto da chamada: o que o app envia ao controller e, quando o
  // backend devolve, o payload que ele repassou para a API de mensagens.
  montarChamadaTesteZap(dados: any, resposta: any) {
    const corpo = { acao: 'notificar', dados: JSON.stringify(dados) };

    let texto = '1) App -> Controller\n';
    texto += 'POST ' + this.est.getServidorCentral() + '\n';
    texto += 'Content-Type: application/json\n\n';
    texto += JSON.stringify(corpo, null, 2);

    // Chamada de autenticação: mostra a resposta crua, que é onde se vê o
    // motivo de o token não ter vindo.
    const auth = resposta && resposta.autenticacao;
    if (auth) {
      texto += '\n\n2) Controller -> Autenticação (' + (auth.origem === 'cache' ? 'token reaproveitado do cache' : 'nova chamada') + ')\n';
      if (auth.origem !== 'cache') {
        texto += 'POST ' + (auth.url || '(url não informada)') + '\n';
        if (auth.cabecalhos && auth.cabecalhos.length) {
          texto += auth.cabecalhos.join('\n') + '\n';
        }
        texto += '\nCorpo enviado:\n';
        texto += JSON.stringify(auth.payload || {}, null, 2) + '\n';
        texto += '\nHTTP ' + (auth.http_code === null ? '(sem resposta)' : auth.http_code) + '\n';
        if (auth.erro_curl) {
          texto += 'Erro cURL: ' + auth.erro_curl + '\n';
        }
        texto += '\nResposta crua:\n';
        texto += (auth.resposta === null || auth.resposta === '' ? '(vazia)' : auth.resposta);
      }
    }

    texto += '\n\n3) Controller -> API de mensagens\n';
    if (resposta && resposta.payload) {
      texto += 'POST ' + (resposta.url || '(url não informada)') + '\n';
      if (resposta.cabecalhos && resposta.cabecalhos.length) {
        texto += resposta.cabecalhos.join('\n') + '\n';
      } else {
        texto += 'Authorization: ' + (resposta.authorization || '(token não informado pelo backend)') + '\n';
      }
      texto += 'Content-Type: application/json\n\n';
      texto += JSON.stringify(resposta.payload, null, 2);
    } else {
      texto += '(aguardando retorno do backend...)';
    }

    return texto;
  }

  async enviarTesteZap() {
    if (!this.testeZapLiberado) return;

    const telefone = (this.testeZap.telefone || '').trim();
    const mensagem = (this.testeZap.mensagem || '').trim();

    if (!telefone || !mensagem) {
      this.dao.toast('e', 'Informe o número e a mensagem.');
      return;
    }

    // 'diagnostico' faz o backend devolver o cabeçalho Authorization completo.
    const dados = { telefone: telefone, mensagem: mensagem, diagnostico: true };

    this.enviandoTesteZap = true;
    this.testeZapComErro = false;
    this.retornoTesteZap = '';
    this.chamadaTesteZap = this.montarChamadaTesteZap(dados, null);

    try {
      const resposta = await this.dao.submeter(dados, 'notificar', true);
      console.log("Retorno do teste de WhatsApp ", resposta);
      this.testeZapComErro = !(resposta && resposta.sucesso === true);
      this.retornoTesteZap = JSON.stringify(resposta, null, 2);
      this.chamadaTesteZap = this.montarChamadaTesteZap(dados, resposta);
    } catch (err) {
      console.error('Erro no teste de WhatsApp:', err);
      this.testeZapComErro = true;
      this.retornoTesteZap = 'Falha na chamada: ' + (typeof err === 'string' ? err : JSON.stringify(err, null, 2));
    }

    this.enviandoTesteZap = false;
  }

  testarPDF() {
    let obj = {
      protocolo: 137,
      nome: 'Paulo Eduardo Santos',
      anoCenso: '2021',
      servidor: 'Denis Alves Dias',
      dataRealizacao: '21/02/2021',
      momento: '14:00:00',
      dia: '18',
      mes: 'junho',
      ano: '2021'
    }
    // this.est.gerarPDF(obj);
  }

  abrirContatoDiviprev() {
    console.log("Exibindo problemas");
    this.exibirProblemas = true;
  }

  fecharProblemas() {
    this.exibirProblemas = false;
  }

  async enviarSuporte() {
    if (!this.item.nome || !this.item.mensagem || !this.item.telefone) {
      this.dao.toast('e', 'Preencha os campos obrigatórios.');
      return;
    }
    console.log("Enviando ", this.item);
    // Simula envio ou chama dao.submeter se houver rota específica
    // Aqui usaremos salvarContato ou similar, mas como é login, talvez salvarSuporte
    let result = await this.dao.submeter(this.item, "salvarContatoZap", false);
    if (result == 'ok') {
      this.dao.toast('s', 'Mensagem enviada com sucesso!');
      this.exibirProblemas = false;
      this.item = { nome: '', matricula: '', telefone: '', mensagem: '' };
    }
  }

  atalhoLogin(event) {

    if (event.keyCode == 13) {
      this.processar();
    }
  }


  isValidDateString(dateStr:any) {
  if (typeof dateStr !== 'string') return false;

  // Validação básica do formato YYYY-MM-DD
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateStr);
  if (!match) return false;

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);

  // Faixas básicas
  if (month < 1 || month > 12) return false;
  if (day < 1) return false;

  // Dias por mês
  const daysInMonth = [
    31,
    (this.isLeapYear(year) ? 29 : 28),
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ];

  return day <= daysInMonth[month - 1];
}

isLeapYear(year:any) {
  return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
}


  processar() {

    this.est.limparCache();

    if (!this.cpf || !this.nascimento) {
      this.dao.toast('e', 'Preencha ambos os campos.');
      return;
    }


    let temp = this.nascimento.split('/');
    temp = (temp[2] + '-' + temp[1] + '-' + temp[0]);

    if(!this.isValidDateString(temp)){
      this.dao.toast('e','Data de nascimento inválida');
      return;
    }

    let dados = {
      cpf: this.cpf,
      nascimento: temp,
      censo: 'teste'
    }

    this.dao.submeter(dados, 'logar').then(async res => {
      if (res.length) {
        localStorage.setItem("cpf_logado", res[0].cpf);
        let ult = localStorage.getItem('ultimoLogado');
        console.log(ult);
        if (ult) {
          if (ult !== res[0].cpf) {
            console.log("Limpar todo o cache");
            localStorage.clear();
            localStorage.setItem("cpf_logado", res[0].cpf);
          }
        }
        localStorage.setItem('ultimoLogado', res[0].cpf);
        console.log("O que chegou ", res);

        // Validação do celular por SMS/WhatsApp desativada: segue direto para o censo
        const zap = res[0]['whatsapp'];
        if (zap) this.est.save('whatsapp', this.est.soNumeros(zap));
        this.est.save('cpf', res[0].cpf);
        const destinoFinal = '/inicial';

        // Verifica se o usuário já aceitou os termos LGPD na versão vigente
        try {
          console.log("Verificando LGPD para ", res[0].cpf);
          const lgpdRes = await this.dao.submeter({ cpf: res[0].cpf }, 'verificarAceiteLgpd', true);
          console.log("Resposta LGPD ", lgpdRes);
          if (lgpdRes && lgpdRes.pendente === true) {
            // Há termos pendentes de aceite
            localStorage.setItem('lgpd_destino', destinoFinal);
            this.router.navigate(['/aceite-termos']);
            return;
          }
        } catch (err) {
          console.error('Erro ao verificar LGPD:', err);
          // Em caso de erro na verificação, segue o fluxo normal
        }

        // Se já aceitou ou não há termos, segue o fluxo normal
        this.router.navigate([destinoFinal]);
        return;
      }

      this.dao.toast('e', 'CPF ou nascimento incorretos');
    });

  }

}
